
import {computed, defineComponent, ref} from 'vue';
import {progress, showShareScreen} from '@/state/game';
import {games, trackList} from '@/data/music';
import {GuessType, guessTypeEmoji, guessTypeInfo, secondSteps} from '@/data/constants';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';

interface RoundResult {
	title: string;
	game: string;
	correct: boolean;
	partial: boolean;
	guesses: string[];
}

export default defineComponent({
	components: {FontAwesomeIcon},
	setup() {
		const resultList = computed<RoundResult[]>(() => trackList.map(track => {
			const roundResult = progress.find(round => round.id === track.id)!;
			const game = games.find(game => game.id === track.gameId)!;
			const guesses = roundResult.guesses.map(guess => guessTypeInfo[guess.type][0]);
			while (guesses.length < secondSteps.length)
				guesses.push('none');

			return {
				title: track.answer,
				game: game.title,
				correct: roundResult.guesses.some(guess => guess.type === GuessType.CORRECT),
				partial: roundResult.guesses.some(guess => guess.type === GuessType.PARTIAL),
				guesses,
			};
		}));

		const copiedStatus = ref(false);

		const copy = async () => {
			const strings = trackList.map(track => {
				const roundResult = progress.find(round => round.id === track.id)!;
				const guesses = roundResult.guesses.map(guess => guessTypeEmoji[guess.type]);
				const correct = roundResult.guesses.some(guess => guess.type === GuessType.CORRECT);

				return `${track.emoji} ${correct ? '🔊' : '🔇'}${guesses.join('')}`;
			});
			const data = `Mario Soundtrack Heardle\n` +
				strings.join('\n') +
				`\nhttps://smw.ltquick.nl/MarioAwards/2022/heardle/`;

			await navigator.clipboard.writeText(data);
			copiedStatus.value = true;
			setTimeout(() => copiedStatus.value = false, 2000);
		};

		const back = () => {
			showShareScreen.value = false;
		};

		return {
			resultList,
			copy, copiedStatus,
			back,
		};
	},
});
